jQuery(document).ready(function ($) {
    'use strict';

    if ( $('#datepicker').length ) {

        $("#datepicker").datepicker({
            dateFormat: "yy-mm-dd",
            firstDay: 1,
            minDate: 0,
            maxDate: "+2Y",
            changeMonth: true,
            changeYear: true,
            prevText: 'Föregående',
            nextText: 'Nästa',
            monthNames: ['januari','februari','mars','april','maj','juni','juli','augusti','september','oktober','november','december'],
            monthNamesShort: ['jan','feb','mar','apr','maj','jun','jul','aug','sep','okt','nov','dec'],
            dayNames: ['söndag','måndag','tisdag','onsdag','torsdag','fredag','lördag'],
            dayNamesShort: ['sön', 'mån','tis','ons','tor','fre','lör'],
            dayNamesMin: ['sö', 'må','ti','on','to','fr','lö'],
            showButtonPanel: true,
            closeText: 'Rensa datum',
        });

    }

});